import { URL_CONTACTUS, URL_SIGNIN } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import {
  Box,
  List,
  ContentBlock,
  Heading,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import { useEffect } from 'react';

import { useConfig } from 'src/modules/appConfig';
import { useHeaderFooterBasicState } from 'src/modules/headerFooterBasicContext';
import { ConnectingSVG } from 'src/views/pages/UnhandledErrorPage/components/ConnectingSVG';
import { CsPhoneNumber } from 'src/views/shared/CsPhoneNumber/CsPhoneNumber';

import translations from './.vocab';

export const UnhandledErrorPage = () => {
  const { t } = useTranslations(translations);
  const { site, absoluteEmployerUrlResolver, isAnz } = useConfig();
  const { setHeaderBasicState, setFooterBasicState } =
    useHeaderFooterBasicState();

  const showCustomerServicePhoneNo = isAnz;
  const contactCustomerServiceUrl = absoluteEmployerUrlResolver(URL_CONTACTUS);
  const signinUrl = absoluteEmployerUrlResolver(URL_SIGNIN);

  useEffect(() => {
    setHeaderBasicState(false);
    setFooterBasicState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContentBlock width="medium">
      <Box background="surface" paddingY="xxlarge" paddingX="gutter">
        <Stack space={['large', 'xlarge']} align="center">
          <ConnectingSVG />

          <Stack space="large" align="center">
            <Heading level="3">{t('Can we try that again?')}</Heading>

            <Text>{t('Step try')}</Text>

            <List type="number" space="small">
              <Text>{t('Step refresh page')}</Text>
              <Text>{t('Step clear browser history')}</Text>
              <Text>
                {t('Step signing in again', {
                  TextLink: (v) => (
                    <TextLink href={signinUrl} hitArea="large">
                      {v}
                    </TextLink>
                  ),
                })}
              </Text>
            </List>

            <Text>
              {t('Reach out Customer Service')} {t('Contact on')}{' '}
              {showCustomerServicePhoneNo ? (
                <CsPhoneNumber site={site} />
              ) : (
                <TextLink href={contactCustomerServiceUrl}>
                  {t('Contact Customer Service')}
                </TextLink>
              )}
            </Text>
          </Stack>
        </Stack>
      </Box>
    </ContentBlock>
  );
};
